let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lU6K4")).then(() => parcelRequire('k46OE'));